<section class="dashboard-container">
  <div class="dashboard-sidebar">
    <div class="row d-flex justify-content-between align-items-center">
      <div class="col-auto">
        <h5 class="font-weight-bold">{{appService?.CoreCommonLiterals?.Summary}}</h5>
      </div>
      <div class="col-10">
        <div class="form-row align-items-center justify-content-xl-end">
          <div class="col-2 col-md-auto text-right">
            <button id="dashboard-btn-collapsed" type="button" class="btn btn-primary mt-3" (click)="sidebar.open();" aria-controls="filters" [tooltip]="appService?.CoreCommonLiterals?.Filter">
              <i class="fa fa-filter"></i>
            </button>
          </div>
        </div>
       
      </div>
    </div>
  </div>
  <div class="widgets-grid mt-3" >
    <div class="widget-container widget-small" *ngIf="dashboardData?.DeviceSummary">
      <div class="widget-card">
        <div class="widget-header">
          <div class="widget-title-section">
            <h5 class="widget-title"></h5>
          </div>
        </div>
        <div class="widget-content">
          <app-status-summary [data]="dashboardData.DeviceSummary"></app-status-summary>
        </div>
      </div>
    </div>

    <div class="widget-container widget-medium-plus" *ngIf="dashboardData?.ConnectivityHistory">
      <div class="widget-card">
        <div class="widget-header">
          <div class="widget-title-section">
            <h5 class="widget-title"></h5>
          </div>
        </div>
        <div class="widget-content">
          <app-xy-chart 
            [data]="dashboardData.ConnectivityHistory"
            [isShared]="false"
            [height]="300"
            [legendPosition]="'top'"
            [granularity]="'hour'">
          </app-xy-chart>
        </div>
      </div>
    </div>

    <div class="widget-container widget-medium" *ngIf="dashboardData?.ConnectivityTable">
      <div class="widget-card">
        <div class="widget-header">
          <div class="widget-title-section">
            <h5 class="widget-title">{{apolusService.literals?.Connectivity}}</h5>
          </div>
        </div>
        <div class="widget-content">
          <app-connectivity-table [data]="dashboardData.ConnectivityTable" *ngIf="dashboardData?.ConnectivityTable?.length"></app-connectivity-table>
          <div class="full-height-message text-center" *ngIf="!dashboardData?.EventsTable?.length">
            <h5 class="text-muted mt-2">{{appService.CoreCommonLiterals.NoData}}</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="widget-container widget-medium" *ngIf="dashboardData?.GlobalConsumption">
      <div class="widget-card">
        <div class="widget-header">
          <div class="widget-title-section">
            <h5 class="widget-title"></h5>
          </div>
        </div>
        <div class="widget-content">
          <app-xy-chart 
            [data]="dashboardData.GlobalConsumption"
            [isShared]="false"
            [height]="400"
            [legendPosition]="'top'"
            [granularity]="'hour'">
          </app-xy-chart>
        </div>
      </div>
    </div>

    <div class="widget-container widget-medium" *ngIf="dashboardData?.EventsTable">
      <div class="widget-card">
        <div class="widget-header">
          <div class="widget-title-section">
            <h5 class="widget-title">{{appService.CoreCommonLiterals.EventSummary}}</h5>
          </div>
        </div>
        <div class="widget-content">
          <app-events-table [data]="dashboardData.EventsTable" *ngIf="dashboardData?.EventsTable?.length"></app-events-table>
          <div class="full-height-message text-center" *ngIf="!dashboardData?.EventsTable?.length">
            <h5 class="text-muted mt-2">{{appService.CoreCommonLiterals.NoDataFound}}</h5>
          </div>
        </div>  
      </div>
    </div>

    <div class="widget-container widget-medium" *ngIf="dashboardData?.Events">
      <div class="widget-card">
        <div class="widget-header">
          <div class="widget-title-section">
            <h5 class="widget-title">{{appService.CoreCommonLiterals?.Events}}</h5>
          </div>
        </div>
        <div class="widget-content">
          <cnm-pie-v2
            [datos]="dashboardData.Events"
            [widget]="eventsWidget"
            [widgetId]="3"
            [isShared]="false"
            [statusZoom]="false"
            [height]="400"
            [showLegend]="true"
            [legendPosition]="'right'">
          </cnm-pie-v2>
        </div>
      </div>
    </div>

  </div>
</section>

<lib-sidebar #sidebar id="filters" [title]="appService?.CoreCommonLiterals?.Filter" [invisibleBackdrop]="true">
  <div class="form-group">
    <lib-datepicker 
      [labelText]="appService.CoreCommonLiterals.RelativeDateFrom"
      [useTime]="true"
      name="dateFrom"
      id="dateFrom"
      [defaultToday]="false"
      [(ngModel)]="dateFrom"
      [disabledFutureDates]="true"
    ></lib-datepicker>
  </div>

  <div class="form-group">
    <lib-datepicker 
      [labelText]="appService.CoreCommonLiterals.RelativeDateTo"
      [useTime]="true"
      name="dateTo"
      id="dateTo"
      [defaultToday]="true"
      [(ngModel)]="dateTo"
      [disabledFutureDates]="true"
      [initCurrentTime]="true"
    ></lib-datepicker>
  </div>
  <div class="form-group">
    <custom-select
      [bordered]="true"
      [(ngModel)]="locality"
      [labelText]="apolusService.literals.Locality"
      name="locality"
      id="locality"
      #localityModel="ngModel"
      [(sourceList)]="localityList"
      required>
    </custom-select>
  </div>
  <div class="form-group">
    <custom-select
      [bordered]="true"
      [(ngModel)]="sector"
      [labelText]="gearAppService.GearCommonLiterals.Sector"
      name="sector"
      id="sector"
      #sectorModel="ngModel"
      [(sourceList)]="sectorList"
      required>
    </custom-select>
  </div>
  <div class="form-group">
    <label for="rate">{{apolusService.literals.RateTitle}}</label>
    <custom-select
      [bordered]="true"
      [(ngModel)]="rate"
      name="rate"
      id="rate"
      #rateModel="ngModel"
      [(sourceList)]="rateList"
      required>
    </custom-select>
  </div>
  <button type="submit" id="btn-applyfilters" class="btn btn-primary btn-block mt-3" (click)="applyFilters(); sidebar.close()" [disabled]="loading">
    <span *ngIf="!loading">{{appService.CoreCommonLiterals?.Apply}}</span>
    <i *ngIf="loading" class="fas fa-circle-notch fa-spin fa-1x fa-fw"></i>
  </button>
</lib-sidebar>
<div class="text-center my-3 not-found-message" *ngIf="loading">
  <i class="fas fa-circle-notch fa-spin fa-3x"></i>
</div>
<div class="not-found-message" *ngIf="!loading && !dashboardData">
  <i class="fa fa-chart-bar fa-5x text-primary"></i>
  <p class="h4 mt-3">{{appService?.CoreCommonLiterals?.NoDataFound}}</p>
</div>
